<template>
    <div>
        <el-dialog width="800px" title="新建项目" :modal-append-to-body="false" :before-close="handleClickCancel" class="custom-height-dialog" :close-on-press-escape="false"
                   :close-on-click-modal="false" :visible.sync="projectAddVisible">
            <div class="project_add_wrap detail" v-loading="loading">
                <el-form size="small" ref="projectForm"   label-position="top"   :model="projectFormData"  :rules="projectFormDataRules">
                    <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
                        <el-col :span="12">
                            <el-form-item label="项目名称" prop="project_manage_name">
                                <el-input  v-model="projectFormData.project_manage_name"  placeholder="请输入项目名称"  maxlength="100"  show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="项目负责人" prop="head_uid">
                                <el-select  :remote-method="getUserList" class="" filterable placeholder="请选择项目负责人"  remote v-model="projectFormData.head_uid">
                                    <el-option v-for="(user, index) in userList" :key="user.uid" :label="user.name" :value="user.uid"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="关联商机" prop="project_ids" class="select_right_handle">
                            <span class="handle_icon_wrap" @click="handleClickRelateHandle('add_business')">
                                <i class="iconfont icon-a-tianjiamiaobian"></i>
                            </span>
                            <el-select  @focus="handleClickChangeBusiness"  popper-class="selectPopperHideClass" class="select_cursor_pointer" filterable placeholder="请选择商机" @remove-tag="handleClickRemoveItem($event,'business')" remote v-model="projectFormData.project_ids" multiple >
                                <el-option v-for="(item, index) in projectFormData.project" @click.native="handleClickItem(item,'business')" :key="item.project_id" :label="item.project_name" :value="item.project_id"></el-option>
                            </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="关联订单" prop="order_ids" class="select_right_handle">
                                <span class="handle_icon_wrap" @click="handleClickRelateHandle('add_order')">
                                    <i class="iconfont icon-a-tianjiamiaobian"></i>
                                </span>
                                <div >
                                    <el-select  @focus="handleClickChangeOrder"  popper-class="selectPopperHideClass" class="select_cursor_pointer" filterable placeholder="请选择订单" @remove-tag="handleClickRemoveItem($event,'order')" remote v-model="projectFormData.order_ids" multiple >
                                        <el-option v-for="(item, index) in projectFormData.order" @click.native="handleClickItem(item,'order')" :key="item.order_id" :label="item.order_num" :value="item.order_id"></el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="关联工单" prop="workorder_ids" class="select_right_handle">
                            <span class="handle_icon_wrap" @click="handleClickRelateHandle('add_work_order')">
                                <i class="iconfont icon-a-tianjiamiaobian"></i>
                            </span>
                                <el-select  @focus="handleClickChangeWorkOrder"  popper-class="selectPopperHideClass" class="select_cursor_pointer" filterable placeholder="请选择工单" @remove-tag="handleClickRemoveItem($event,'workorder')" remote v-model="projectFormData.workorder_ids" multiple >
                                    <el-option v-for="(item, index) in projectFormData.workorder" @click.native="handleClickItem(item,'workorder')" :key="item.workorder_id" :label="item.workorder_num" :value="item.workorder_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="项目地址" prop="addr">
                                <el-row :gutter="20" type="flex">
                                    <el-col :span="6">
                                        <el-cascader  :options="addressOptions" v-model="projectFormData.location.value"  separator="-" filterable @change="handleChangeCascader" ref="cascader" placeholder="请选择项目地址"></el-cascader>
                                    </el-col>
                                    <el-col :span="18">
                                        <el-input  v-model="projectFormData.addr"  placeholder="请输入详细地址" ></el-input>
                                    </el-col>
                                </el-row>

                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="项目概况" prop="note">
                                <el-input type="textarea" :rows="5" v-model="projectFormData.note" placeholder="请输入项目概况"   ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="项目资料" prop="files">
                                <div class="file_upload_wrap">
                                    <div v-if="projectFormData.files.length===0" class="file_outer_wrap">
                                        <img alt=""  src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"  width="36">
                                        <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                        <p class="file_type_hint">支持.rar .zip .doc .docx .pdf .jpg...</p>
                                        <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                                    </div>
                                    <ul v-else class="upload_file_list">
                                        <li v-for="(file,file_idx) in projectFormData.files" :key="file_idx" class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img alt="" class="file_img"  src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                    <!--                                                <p class="file_size" v-text="file.file_size"></p>-->
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览"  effect="dark"  placement="top">
                                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line" v-if="!projectId || file.type == 'project_manage'"></span>
                                                <el-tooltip content="删除"  effect="dark"  placement="top" v-if="!projectId || file.type == 'project_manage'">
                                                    <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="projectFormData.files.splice(file_idx,1)">
                                                        <i class="iconfont icon-shanchu1"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                        <li class="upload_file_btn_wrap">
                                            <i class="el-icon-plus"></i>
                                            <span>添加附件</span>
                                            <input class="upload_input"  multiple  type="file"  @change="handleUploadFileChange($event)">
                                        </li>
                                    </ul>
                                </div>
                            </el-form-item>
                        </el-col>

                    </el-row>

                </el-form>
                <el-image :preview-src-list="previewImgList" :src="previewImgSrc" ref="preview_img" style="display: none"></el-image>
            </div>
            <div slot="footer">
                <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
                <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交</el-button>
            </div>

        </el-dialog>
        <ChangeBusiness  v-if="changeBusinessDialog" :business_pk_sort="business_pk_sort" :changeBusinessDialog.sync="changeBusinessDialog" :selectBusinessData="projectFormData.project" @success="changeBusinessSuccess"/>
        <ChangeOrder  v-if="changeOrderDialog" :order_pk_sort="order_pk_sort" :changeOrderDialog.sync="changeOrderDialog" :selectOrderData="projectFormData.order" @success="changeOrderSuccess"/>
        <ChangeWorkOrder  v-if="changeWorkOrderDialog" :work_order_pk_sort="work_order_pk_sort" :changeWorkOrderDialog.sync="changeWorkOrderDialog" :selectWorkOrderData="projectFormData.workorder" @success="changeWorkOrderSuccess"/>
        <RelatedHandle ref="relatedHandle" @relatedHandleSuccess="relatedHandleSuccess"/>
    </div>

</template>
<script>
import {GetUserList,getProjectList,getOrderList,ProjectManageAdd,ProjectManageEdit,ProjectManageDetail,ProjectFileList} from '@/api'
import {formatFileSize,getWorldArea,getFileType} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import ChangeBusiness from  "./change_business"
import ChangeOrder from  "./change_order"
import ChangeWorkOrder from  "./change_work_order"
import RelatedHandle from "./related_handle.vue";
export default {
    name: 'project_tpl',
    components: {
        ChangeBusiness,
        ChangeOrder,
        ChangeWorkOrder,
        RelatedHandle
    },
    props: {
        projectAddVisible: {
            type: Boolean,
            default: false,
        },
        projectId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            projectFormData: {
                project_manage_name:"",
                head_uid:"",

                project:[],
                project_ids:[],
                order:[],
                order_ids:[],
                workorder:[],
                workorder_ids:[],


                country:'',//国家
                province:'',//省份
                city:'',//城市
                area:'',//地区
                country_region:'',//文本

                location:{
                  value:[],
                  text:''
                },
                addr:"",
                note: "",
                files:[]
            },
            projectFormDataRules:{
                project_manage_name:[{required: true, message: '请输入项目名称', trigger: 'blur'}],
                head_uid:[{required: true, message: '请选择项目负责人', trigger: 'change'}]
            },
            previewImgList: [],
            previewImgSrc: "",
            userList:[],
            businessList:[],
            orderList:[],
            addressOptions: getWorldArea("3"),
            changeOrderDialog:false,
            order_pk_sort:null,
            changeWorkOrderDialog:false,
            work_order_pk_sort:null,
            changeBusinessDialog:false,
            business_pk_sort:null
        }
    },
    created() {

        if(this.projectId){
            this.getProjectDetail()
        }else{
            this.getUserList()
        }


    },
    computed: {

    },
    mounted() {

    },
    methods: {
        getProjectDetail(){
            this.loading = true
            ProjectManageDetail({ id:this.projectId }).then((res) => {
                if (res.code == 200) {
                    let {project_manage_name, head_uid, addr, note,  relates,  country, province, city, area, country_region,head_user} = res.data
                    this.projectFormData.project_manage_name = project_manage_name
                    this.projectFormData.head_uid = head_uid
                    this.projectFormData.country = country
                    this.projectFormData.province = province
                    this.projectFormData.city = city
                    this.projectFormData.country_region = country_region
                    this.projectFormData.addr = addr
                    this.projectFormData.note = note


                    let location_value = [country, province, city].filter(item => item !== '');
                    this.projectFormData.location ={
                        value:location_value.map(Number),
                        text: country_region
                    }

                    this.projectFormData.project = relates.filter(item=> item.relate_type == 'project').map((item)=>{return {project_id:item.relate_id,project_name:item.relate_detail.name,project_num:''}})
                    this.projectFormData.order = relates.filter(item=> item.relate_type == 'order').map((item)=>{return {order_id:item.relate_id,order_num:item.relate_detail.order_num,project_id:''}}),
                    this.projectFormData.workorder = relates.filter(item=> item.relate_type == 'workorder').map((item)=>{return {workorder_id:item.relate_id,workorder_num:item.relate_num,project_id:''}}),
                    this.projectFormData.project_ids = this.projectFormData.project.map( item => item.project_id)
                    this.projectFormData.order_ids = this.projectFormData.order.map( item => item.order_id)
                    this.projectFormData.workorder_ids = this.projectFormData.workorder.map( item => item.workorder_id)
                    this.businessList = this.projectFormData.project.map((item)=> {return {project_id:item.project_id,name:item.project_name}})

                    this.userList = [{uid:head_user.id,name:head_user.name}]
                    this.getProjectFileList()
                }else{
                    this.loading = false
                }

            });
        },
        getProjectFileList(){
            ProjectFileList({ project_manage_id:this.projectId }).then((res) => {
                if (res.code == 200) {
                    this.projectFormData.files = res.data ?  res.data.map((item)=>{return {type:item.type,file_path:item.file_path,file_name:item.file_name}}) : []
                }
                this.loading = false
            })
        },

        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        //获取关联的商机列表
        getBusinessTableList(keyword) {
            let pk_sort_id = [
                ...this.getValidIds(this.projectFormData.order),
                ...this.getValidIds(this.projectFormData.workorder)
            ];
            // let pk_sort_id = this.projectFormData.order.map(item => item.project_id).concat(this.projectFormData.workorder.map(item => item.project_id))
            getProjectList({
                keyword,
                pk_sort:{
                    id:pk_sort_id,
                }
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.businessList = data
                } else {
                    this.$message.error(res.message)
                }

            })
        },
        getValidIds(arr){
            const result = [];
            for (const item of arr) {
                const id = item.project_id;
                if (id != null && id !== '') result.push(id);
            }
            return result;
        },

        // 选择商机
        handleClickChangeBusiness(){
            let pk_sort_id = [
                ...this.getValidIds(this.projectFormData.order),
                ...this.getValidIds(this.projectFormData.workorder)
            ];
            this.business_pk_sort = {
                id:pk_sort_id
            }
            this.changeBusinessDialog = true
        },
        // 选择商机回调
        changeBusinessSuccess(data){
            this.projectFormData.project_ids = []
            this.projectFormData.project = []
            data.forEach((item)=>{
                let json = {project_id:item.project_id,project_num:'',project_name:item.project_name}
                this.projectFormData.project_ids.push(item.project_id)
                this.projectFormData.project.push(json)
            })
        },

        // 选择订单
        handleClickChangeOrder(){
            let pk_sort_project_id = this.projectFormData.project.map(item => item.project_id) //关联订单中的商机id
            let pk_sort_workorder_id = this.projectFormData.workorder.map(item => item.workorder_id) //关联订单中的商机id
            this.order_pk_sort = {
                project_id:pk_sort_project_id,
                // workorder_id:pk_sort_workorder_id
            }
            this.changeOrderDialog = true
        },
        // 选择订单回调
        changeOrderSuccess(data){
            this.projectFormData.order_ids = []
            this.projectFormData.order = []
            data.forEach((item)=>{
                let json = {order_id:item.order_id,order_num:item.order_num,project_id:item.project_id}
                this.projectFormData.order_ids.push(item.order_id)
                this.projectFormData.order.push(json)
            })
        },

        // 选择工单
        handleClickChangeWorkOrder(){
            let pk_sort_project_id = this.projectFormData.project.map(item => item.project_id)
            let pk_sort_order_id = this.projectFormData.order.map(item => item.order_id)
            this.work_order_pk_sort = {
                order_id:pk_sort_order_id,
                project_id:pk_sort_project_id,
            }
            this.changeWorkOrderDialog = true
        },
        // 选择工单回调
        changeWorkOrderSuccess(data){
            this.projectFormData.workorder_ids = []
            this.projectFormData.workorder = []
            data.forEach((item)=>{
                let json = {project_id:item.project_id,workorder_num:item.workorder_num,workorder_id:item.workorder_id}
                this.projectFormData.workorder_ids.push(item.id)
                this.projectFormData.workorder.push(json)
            })
        },


        // 选择商机、订单、工单
        handleClickItem(item,type){
            if(type == 'business'){
                if(this.projectFormData.project.findIndex(find => find.project_id == item.project_id) >-1){
                    this.projectFormData.project.splice(this.projectFormData.project.findIndex(find => find.project_id == item.project_id),1)
                }else{
                    let json = {project_id:item.project_id,project_name:item.name,project_num:''}
                    this.projectFormData.project.push(json)
                }
            }
        },
        // 删除商机、订单、工单
        handleClickRemoveItem(value,type){
            if(type == 'business'){
                this.projectFormData.project.splice(this.projectFormData.project.findIndex(find => find.project_id == value),1)
            }else if(type == 'order'){
                this.projectFormData.order.splice(this.projectFormData.order.findIndex(find => find.order_id == value),1)
            }else if(type == 'workorder'){
                this.projectFormData.workorder.splice(this.projectFormData.workorder.findIndex(find => find.workorder_id == value),1)
            }
        },
        // 选择地区
        handleChangeCascader(e){
            this.projectFormData.location.value = e;
            this.projectFormData.location.text = this.$refs["cascader"].getCheckedNodes()[0].pathLabels.join('-');
            this.projectFormData.country = this.projectFormData.location.value[0]?this.projectFormData.location.value[0] : ''//国家
            this.projectFormData.province = this.projectFormData.location.value[1]?this.projectFormData.location.value[1] : ''//省份
            this.projectFormData.city = this.projectFormData.location.value[2]?this.projectFormData.location.value[2] : ''//城市
            this.projectFormData.country_region = this.projectFormData.location.text//文本
        },
        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.projectFormData.files.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        // 预览
        handleClickPreview(file){
            let file_type = getFileType(file.file_name)
            if (file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        // 关联的功能操作
        handleClickRelateHandle(type,data){
            this.$refs.relatedHandle.projectId = this.projectId
            this.$refs.relatedHandle.handleClickRelateHandle(type,data)
        },
        relatedHandleSuccess(data){

        },
        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:projectAddVisible', false)
        },
        handleClickConfirm(){
            this.$refs.projectForm.validate(valid => {
                if (valid) {
                    this.BtnDisabled = true;
                    let postData = JSON.parse(JSON.stringify(this.projectFormData))
                    delete postData.project_ids;
                    delete postData.order_ids;
                    delete postData.workorder_ids;
                    delete postData.location
                    if(this.projectId){
                         postData.id = this.projectId
                        ProjectManageEdit(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit('success')
                                this.$emit('update:projectAddVisible', false)
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }else{
                        ProjectManageAdd(postData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.$emit('success')
                                this.$emit('update:projectAddVisible', false)
                            } else {
                                this.BtnDisabled = false;
                            }
                        }).catch(() => {
                            this.BtnDisabled = false;
                        })
                    }

                }
           })
        },
    },

}
</script>
<style lang="scss" scoped>
@import "@/styles/project_management.scss";


</style>

